export default "__VITE_ASSET__9873e215__"